export function disablePointerEvents(parentNode, draggableClassName) {
    // Give all other draggable items the `no-hover` class, to prevent activation of hover CSS state.
    Array.from(parentNode.getElementsByClassName(draggableClassName)).forEach((el) => {
        el.classList.add('no-hover');
    });
    // Prevent pointer-events on `btn` classes & tooltips
    Array.from(parentNode.getElementsByClassName('btn')).forEach((btn) => {
        btn.style.setProperty('pointer-events', 'none');
    });
    Array.from(parentNode.getElementsByClassName('tooltip')).forEach((tooltip) => {
        tooltip.style.setProperty('display', 'none');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-label')).forEach((label) => {
        label.style.setProperty('display', 'none');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-markers')).forEach((label) => {
        label.style.setProperty('display', 'none');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-crosshair')).forEach((label) => {
        label.style.setProperty('display', 'none');
    });
}
export function enablePointerEvents(parentNode, draggableClassName) {
    Array.from(parentNode.getElementsByClassName('btn')).forEach((btn) => {
        btn.style.setProperty('pointer-events', 'auto');
    });
    Array.from(parentNode.getElementsByClassName(draggableClassName)).forEach((el) => {
        el.classList.remove('no-hover');
    });
    Array.from(parentNode.getElementsByClassName('tooltip')).forEach((tooltip) => {
        tooltip.style.setProperty('display', 'initial');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-label')).forEach((label) => {
        label.style.setProperty('display', 'initial');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-markers')).forEach((label) => {
        label.style.setProperty('display', 'initial');
    });
    Array.from(parentNode.getElementsByClassName('highcharts-crosshair')).forEach((label) => {
        label.style.setProperty('display', 'initial');
    });
}
